<div class="ap-configs">
  <h2 class="ap-configs__title">AP Configurations</h2>

  @if (ApConfigs.length === 0) {
    <p class="ap-configs__empty">No AP integrations configured yet.</p>
  }

  @for (ApConfig of ApConfigs; track ApConfig) {
    <app-display-card [justifyContent]="'start'" class="ap-config-card">
      <header class="ap-config-card__head">
        <h3 class="ap-config-card__name mb-0">
          {{ ApConfig.apDisplayName }} -
          {{ ApConfig.v3CutOverDate ? 'V3' : 'V2' }}
        </h3>
      </header>

      <dl class="ap-config-card__grid">
        @for (
          obj of ApConfigFieldFriendlyNameMap
            | keyvalue: keyValuePairDefaultOrder;
          track obj
        ) {
          <div class="ap-config-card__cell">
            <dt>{{ obj.value }}</dt>
            <dd>{{ formatValue(ApConfig[obj.key]) }}</dd>
          </div>
        }
      </dl>
    </app-display-card>
  }
</div>
